<template>
  <div class="welcome container">
    <div class="row vh-100 justify-content-center align-items-center">
      <div class="col-md-8 col-12 ">
        <div class="card shadow-sm border-1 blur-card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-5
                  d-flex justify-content-center align-items-center">
                  <img src="../assets/img/logo.svg" alt="logo" class="">
              </div>
              <div class="col-12 col-md-7">
                <div class="form-container">
                  <div class="login" v-if="showLoginPage">
                    <Login @goToChatRoom="goToChatRoom"></Login>
                    <p class="text-center mb-3">If you have not a account, <span class="text-bold text-primary hand" @click="showLoginPage=!showLoginPage">Create New Account here!</span></p>
                  </div>
                  <div class="sign-up" v-else>
                    <SignUp @goToChatRoom="goToChatRoom"></SignUp>
                    <p class="text-center mb-3">If you have a account, <span class="text-bold text-primary hand" @click="showLoginPage=!showLoginPage">Login here!</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignUp from "@/components/SignUp";
import Login from "@/components/Login";
import {ref} from "vue";
import {useRouter} from "vue-router";

export default {
  name: "WelcomeView",
  components: {Login, SignUp},
  setup(){
    let showLoginPage = ref(true);
    let router = useRouter();
    let goToChatRoom = ()=>{
      router.push({name: 'chatroom'});
    }
    return {showLoginPage, goToChatRoom};
  }
}
</script>

<style scoped>
.h-45{
  height: 480px;
}
.h-40{
  height: 400px;
}
.hand{
  cursor: pointer;
}
.blur-card{
  background: rgba(255,255,255,.5);
  backdrop-filter: blur();
}
</style>